<template>
    <div class="gloves-sport-page">
        <flickity-box class="flickity" ref="flickity" :options="flickityOptions">
            <div class="carousel-cell">

                <div class="desc" v-if="lang == 'fr'">
                    <h2>Gants et sports</h2>
                    <p>
                        Pluie, bourrasque, gel, neige ... les gants d'Amélie assurent

                        d'excellentes sensations de toucher dans toutes les activités

                        sportives ou de la vie quotidienne, avec une fiabilité et une

                        fidélité au fil des années ... mais aussi dans les moments

                        d'exception comme les compétitions ou évènements. Les

                        gants d’Amélie peuvent être portés sans contrainte et

                        assurent confort et grande élégance pour ceux qui les

                        portent.

                        Par temps de pluie, il est important de les imperméabiliser

                        au préalable afin d’éviter que le cuir ne s’abîme.
                    </p>
                </div>
                <div class="desc" v-if="lang == 'en'">
                    <h2>Gloves and sports</h2>
                    <p>
                        Rain, storm, frost, snow…  Amelie’s gloves provide excellent

                        touch sensations in all aspects of sports or daily life but also in

                        sports competitions and special events, with unfailing reliability

                        over the years. Amelie's gloves can be worn without restraints

                        since they ensure not only comfort but also great elegance. In

                        anticipation of rainy weather, to protect the leather, it is

                        important to waterproof them.
                    </p>
                </div>
                <div class="img">
                    <img src="../assets/sport_1.png" />
                </div>

            </div>
            <div class="carousel-cell">
                <div class="desc" v-if="lang == 'fr'">
                    <h2>Gants et sports</h2>
                    <p>
                        Le golf nous a fourni le meilleur laboratoire d'observation et

                        d'amélioration pendant plus de dix ans.

                        Aujourd'hui, les cavaliers, joggeurs, motards, conducteurs,

                        cyclotouristes ou marcheurs : tous peuvent en bénéficier.

                        Avec les gants d'Amélie, ils ont vraiment trouvé de la chaleur, du

                        plaisir et de « vraies » belles sensations dans leur activité

                        d'extérieur...
                    </p>
                </div>
                <div class="desc" v-if="lang == 'en'">
                    <h2>Gloves and sports</h2>
                    <p>
                        The golf course has provided us with the best observation and

                        improvement laboratory for over 10 years.Today, riders, joggers,

                        bikers, drivers, cyclists, and hikers alike can benefit from our

                        hands-on technology. With Amelie’s gloves, all sportspeople can

                        truly and warmly enjoy themselves in outdoor activities.
                    </p>
                </div>
                <div class="img">
                    <img src="../assets/sport_2.png" />
                </div>

            </div>
            <div class="carousel-cell">
                <div class="desc" v-if="lang == 'fr'">
                    <h2>Gants et sports</h2>
                    <p>
                        Les gants d'Amélie enchantent votre quotidien sur

                        les trois modes majeurs de l'élégance :

                        la texture, la couleur, et la coupe.
                    </p>
                </div>
                <div class="desc" v-if="lang == 'en'">
                    <h2>Gloves and sports</h2>
                    <p>
                        Amelie’s gloves enhance your day according to the

                        three major rules of elegance: the right texture,

                        the right color, the right cut.
                    </p>
                </div>
                <div class="img">
                    <img src="../assets/sport_3.png" />
                </div>

            </div>

        </flickity-box>
    </div>
</template>

<script>
  import FlickityBox from './FlickityBox';

  export default {
    name: 'gloves-sport-page',
    props: ['lang'],
    components: {
      FlickityBox,
    },
    data() {
      return {
        flickityOptions: {
          freeScroll: false,
          imagesLoaded: true,
          // prevNextButtons: false,
          // pageDots: false,
          wrapAround: true,
          adaptiveHeight: false,
          cellAlign: 'left',
        },
      };
    },
  };
</script>
<style lang="scss">
    .gloves-sport-page {
        .flickity {
            @media screen and (min-width:768px) {
            .carousel-cell {
                flex: 0;
                .desc {
                    margin-top: auto;
                    margin-left:2rem;
                    margin-bottom:5rem;
                    flex: 1 200px;

                    p {
                        background: url('../assets/desc_bg.jpg') center ;
                        color:#555;
                        background-size:contain;
                        padding:0.5rem;
                        border:1px darkgrey solid;
                    }

                }

                .img {
                    flex: 60%;
                }
            }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/GlovesSportPage.vue